import { Region, getConfig } from "config/config";

export function formatMoney(amount: number, options: { monthly?: boolean } = {}): string {
  const { region } = getConfig();
  const currencySumbol = region === Region.AU ? "$" : "£";
  const { monthly = false } = options;
  return `${currencySumbol}${Number.isInteger(amount) ? amount : amount.toFixed(2)}${monthly ? "/month" : ""}`;
}
